var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _g, _ellipse, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel1Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 304,
    viewBox: "0 0 790 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 39.2695H417.467L402.072 269.065H387.053L376.539 39.2695Z",
    fill: "url(#paint0_linear_6920_2979)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 484.596H417.467L402.072 254.8H387.053L376.539 484.596Z",
    fill: "url(#paint1_linear_6920_2979)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M685.002 241.477L685.002 282.404L389.869 267.009L389.869 251.99L685.002 241.477Z",
    fill: "url(#paint2_linear_6920_2979)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.001 241.477L106.001 282.404L404.137 267.009L404.137 251.99L106.001 241.477Z",
    fill: "url(#paint3_linear_6920_2979)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M557.974 502.412L522.529 522.876L388.295 259.589L401.302 252.079L557.974 502.412Z",
    fill: "url(#paint4_linear_6920_2979)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.124 0.992189L216.679 21.456L379.08 271.95L392.087 264.44L252.124 0.992189Z",
    fill: "url(#paint5_linear_6920_2979)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M656.448 388.959L635.984 424.403L388.089 263.506L395.599 250.499L656.448 388.959Z",
    fill: "url(#paint6_linear_6920_2979)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.668 99.4746L118.204 134.919L384.095 270.654L391.605 257.647L138.668 99.4746Z",
    fill: "url(#paint7_linear_6920_2979)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.473 522.879L233.028 502.415L393.927 254.522L406.934 262.032L268.473 522.879Z",
    fill: "url(#paint8_linear_6920_2979)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.443 21.4531L537.998 0.989276L402.262 266.878L415.27 274.388L573.443 21.4531Z",
    fill: "url(#paint9_linear_6920_2979)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.019 424.402L134.555 388.958L397.844 254.725L405.354 267.732L155.019 424.402Z",
    fill: "url(#paint10_linear_6920_2979)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M671.916 134.92L651.452 99.4755L400.956 261.875L408.466 274.882L671.916 134.92Z",
    fill: "url(#paint11_linear_6920_2979)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 261.999,
    r: 97.3333,
    fill: "url(#paint12_linear_6920_2979)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6920_2979)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 261.999,
    r: 63.2667,
    fill: "url(#paint13_radial_6920_2979)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 261.999,
    r: 63.2667,
    fill: "url(#paint14_radial_6920_2979)",
    fillOpacity: 0.29
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 261.999,
    r: 63.2667,
    fill: "url(#paint15_linear_6920_2979)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 261.999,
    r: 69.35,
    stroke: "url(#paint16_linear_6920_2979)",
    strokeWidth: 12.1667
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 262,
    r: 76.0417,
    stroke: "white",
    strokeWidth: 1.21667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6920_2979)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_6920_2979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.635 261.391H387.665M405.581 261.391H405.611M390.626 273.355C392.122 274.252 394.215 274.85 396.608 274.85C399.001 274.85 401.095 274.252 402.59 273.355",
    stroke: "white",
    strokeWidth: 5.98194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.545 244.343C420.255 247.74 422.102 251.742 422.929 256.008C423.94 256.497 424.793 257.262 425.39 258.214C425.987 259.167 426.303 260.268 426.303 261.391C426.303 262.515 425.987 263.616 425.39 264.568C424.793 265.521 423.94 266.285 422.929 266.775C421.637 272.797 418.32 278.195 413.53 282.067C408.74 285.938 402.767 288.051 396.608 288.051C390.449 288.051 384.476 285.938 379.686 282.067C374.896 278.195 371.579 272.797 370.288 266.775C369.276 266.285 368.423 265.521 367.826 264.568C367.23 263.616 366.913 262.515 366.913 261.391C366.913 260.268 367.23 259.167 367.826 258.214C368.423 257.262 369.276 256.497 370.288 256.008C371.527 249.937 374.822 244.481 379.616 240.557C384.411 236.634 390.413 234.485 396.608 234.473C402.59 234.473 407.077 237.763 407.077 241.95C407.077 246.137 404.385 249.428 401.095 249.428C398.702 249.428 396.608 248.231 396.608 246.437",
    stroke: "white",
    strokeWidth: 5.98194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 394.5,
    rx: 395,
    ry: 48.5,
    fill: "url(#paint17_radial_6920_2979)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.532,
    cy: 394.501,
    rx: 254.126,
    ry: 9.7,
    fill: "url(#paint18_radial_6920_2979)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6920_2979",
    x: 320.567,
    y: 186.566,
    width: 150.867,
    height: 150.865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.358333 0 0 0 0 0.0840788 0 0 0 0 0.0627083 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6920_2979"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_6920_2979",
    x: 359.436,
    y: 231.482,
    width: 74.345,
    height: 70.027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.98194
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24323
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6920_2979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6920_2979",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.98194
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.99097
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6920_2979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6920_2979",
    x1: 397.003,
    y1: 39.2695,
    x2: 397.003,
    y2: 269.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6920_2979",
    x1: 397.003,
    y1: 484.596,
    x2: 397.003,
    y2: 254.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6920_2979",
    x1: 657.591,
    y1: 261.94,
    x2: 389.869,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6920_2979",
    x1: 110.131,
    y1: 261.94,
    x2: 404.137,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6920_2979",
    x1: 526.546,
    y1: 488.906,
    x2: 392.687,
    y2: 257.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6920_2979",
    x1: 236.467,
    y1: 14.8011,
    x2: 383.468,
    y2: 269.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6920_2979",
    x1: 622.478,
    y1: 392.976,
    x2: 390.625,
    y2: 259.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6920_2979",
    x1: 132.013,
    y1: 119.262,
    x2: 386.629,
    y2: 266.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6920_2979",
    x1: 264.456,
    y1: 488.909,
    x2: 398.315,
    y2: 257.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6920_2979",
    x1: 553.655,
    y1: 14.7982,
    x2: 406.654,
    y2: 269.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6920_2979",
    x1: 168.525,
    y1: 392.975,
    x2: 400.378,
    y2: 259.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6920_2979",
    x1: 658.107,
    y1: 119.263,
    x2: 403.492,
    y2: 266.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6920_2979",
    x1: 396,
    y1: 164.666,
    x2: 396,
    y2: 359.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C35A2A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_6920_2979",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(396 261.999) rotate(90) scale(98.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA9062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C67341"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_6920_2979",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(368.017 238.882) rotate(-44.2462) scale(65.3895 34.7067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28787",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6920_2979",
    x1: 396,
    y1: 198.732,
    x2: 396,
    y2: 325.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6920_2979",
    x1: 396,
    y1: 198.732,
    x2: 396,
    y2: 325.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C76030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_6920_2979",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 394.5) rotate(90) scale(48.5 395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B36E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F57",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_6920_2979",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.532 394.501) rotate(90) scale(9.7 254.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B36E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F57",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6920_2979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.7833,
    height: 71.7833,
    fill: "white",
    transform: "translate(360.717 225.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1Badge);
export default __webpack_public_path__ + "static/media/Level1Badge.047ba221c34d2cafd2f8424bbb7b0e7c.svg";
export { ForwardRef as ReactComponent };